import React from 'react';
import '../styles/_Menu.css';
import { Row } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
//import { changeView } from "../actions/actions";
import { connect } from 'redux-zero/react';
import { changeToSpanish, changeToEnglish } from "../actions/actions";

const Menu = ({isSpanish}) => {
    return (
        <Row >
            <nav>
                <ul className="mcd-menu">
                    <li>
                        <NavLink to={'/home'}>
                            <i className="fa fa-home"></i>
                            <strong>{isSpanish === true ? 'Inicio' : 'Home'}</strong>
                            <small>{isSpanish === true ? 'hogar dulce hogar' : 'sweet home'}</small>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/aboutme'} className={"active"}>
                            <i className="fa fa-edit"></i>
                            <strong>{isSpanish === true ? 'Acerca de mi' : 'About me'}</strong>
                            <small>{isSpanish === true ? 'y mi mundo' : 'and my world'}</small>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/skills'} className="notactive">
                            <i className="fa fa-gift"></i>
                            <strong>{isSpanish === true ? 'Habilidades' : 'Skills'}</strong>
                            <small>{isSpanish === true ? 'super poderes' : 'super powers'}</small>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/portfolio'} className='notactive'>
                            <i className="fa fa-picture-o"></i>
                            <strong>{isSpanish === true ? 'Mis trabajos' : 'My work'}</strong>
                            <small>{isSpanish === true ? 'mi super galería' : 'a joy gallery'}</small>
                        </NavLink>
                    </li>
                    {/*<li>
                        <NavLink to={'/resume'} className={"notactive"}>
                            <i className="fa fa-comments-o"></i>
                            <strong>{isSpanish === true ? 'Experiencia' : 'Resume'}</strong>
                            <small>{isSpanish == true ? 'y un poco más' : 'what they say'}</small>
                        </NavLink>
                    </li>*/}
                    <li>
                        <NavLink to={'/contact'} className={"notactive"}>
                            <i className="fa fa-envelope-o"></i>
                            <strong>{isSpanish === true ? 'Contáctame' : 'Contact'}</strong>
                            <small>{isSpanish === true ? 'déjame un mensaje' : 'drop a line'}</small>
                        </NavLink>
                    </li>
                   {/*<li>
                        <a href="">
                            <i class="fa fa-globe"></i>
                            <strong>Contacts</strong>
                            <small>drop a line</small>
                        </a>
                   </li>*/}
                </ul>
                <div className='lang-change-menu'>
                    <div className={isSpanish ? 'left-menu' : 'right-menu'}>
                        <a className='es-menu' title='Cambiar idioma a español' onClick={() => changeToSpanish()}><span> ES </span></a>
                    </div>
                    <div className={isSpanish ? 'right-menu' : 'left-menu'}>
                        <span className='active-menu' onClick={() => changeToEnglish()}> EN </span>
                    </div>
                </div>
            </nav>
        </Row>
    )
}

//export default Menu;
const mapToProps = ({ actualPage, isSpanish }) => ({ actualPage, isSpanish });
export default connect(mapToProps)(Menu);


// WEBPACK FOOTER //
// ./src/components/Menu.js